import { render, staticRenderFns } from "./ReportGroupsList.vue?vue&type=template&id=44a50083"
import script from "./ReportGroupsList.vue?vue&type=script&lang=js"
export * from "./ReportGroupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports